var map = {
	"./close.svg": 956,
	"./euro.svg": 452,
	"./flatten.svg": 957,
	"./globe.svg": 958,
	"./group.svg": 959,
	"./pvp.svg": 960,
	"./rouble.svg": 961,
	"./thunder.svg": 962,
	"./user-ban.svg": 963,
	"./v.svg": 964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 955;